/** Matches the server's suggested-price calculation between USD input blurs. */
export function calculateRecommendedPriceUzs(
	priceUsd: number,
	rate: number,
	commissionPercent: number,
): number {
	const raw = priceUsd * rate * (1 + commissionPercent / 100)
	return Math.round(raw / 1000) * 1000
}
